/**
 * Module bdc
 * @module app.bdc
 */
define([
    'angular',
    'moment',
    'bootstrap',
    'ui-bootstrap4',
    'angular-ui-notification',
    'angular-fr',
    'modules/bdc/common/index',
    'modules/bdc/list/index',
    'modules/bdc/reports/index',
    'modules/bdc/cpi/index',
    'modules/bdc/files/index'
], function(angular, moment) {


    angular.module('app.bdc', ['app.bdc.common', 'app.bdc.list', 'app.bdc.reports', 'app.bdc.cpi', 'app.bdc.files']);
});
